<template>
	<div id="page-container">
		<header>
			<router-link to="/">
				<div class="logo">
					<img src="./assets/images/logo.png" height="85%" alt="Jessica and Krystal">
					<span>Jessica and Krystal</span>
				</div>
			</router-link>
			
		</header>
		<main>
			<router-view></router-view>
		</main>
		<footer>
			<div class="table-col">&copy; 2020 Jessica and Krystal</div>
			<div class="table-col center made-with">Made with ❤</div>
			<div class="table-col right">Support | Terms | Policy</div>
		</footer>
	</div>
</template>

<script>
	//import Navigation from "./components/Navigation.vue";

	export default
	{
		name: 'app',
		//components: { Navigation }
	}
</script>
